module.exports = __webpack_public_path__ + "img/weibo.26f8c259.png";